<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div class="flex mb-2">
    <button (click)="onTagAdd()" pButton type="button" label="Add Kit Tag" icon="pi pi-plus" class="p-button-sm"
      [disabled]="isReadOnly()"></button>
    <span
      style="margin-left:10px; padding-top:7px;  font-size:small; font-variant: small-caps; color: red;">{{statusMessage()}}</span>
  </div>
  <div class="py-2 w-full h-full">
    <prox-ag-grid [gridOptions]="tagGridOptions" [rowData]="tags"></prox-ag-grid>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" [isReadOnly]="isReadOnly()" (undo)="onUndo()" (save)="onSave()"
    (cancel)="onCancel()"></prox-save-cancel>
</ng-template>